<template>
    <el-dialog :title="$t('import')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               custom-class="medium-dialog">
        <div class="content">
            <el-upload
                class="upload"
                drag
                action=""
                :multiple="false"
                :show-file-list="false"
                :http-request="httpRequest">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{ $t('clickUpload') }}</div>
            </el-upload>
            <div class="upload-hint">
                <p class="text">{{ $t('uploadTextHint') }}</p>
                <div class="download">
                    <a href="javascript:void(0);" class="clickable" @click="downloadTempHandle()">{{ $t('downloadTemp') }}</a>
                </div>
            </div>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button
                size="mini"
                @click="dialogVisible = false">{{ $t('close') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import {merchantImport, merchantTempDownload} from "@/api/modules/api";

export default {
    name: 'Import',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
    },
    data () {
        return {
            dialogVisible: false,
            disabled: false,
        }
    },
    created () { },
    mounted () { },
    components: {},
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
        },
    
        // 下载模板
        downloadTempHandle () {
            merchantTempDownload().then(res => {
                let content = res
                let blob = new Blob([content], { type: 'application/vnd.ms-excel' })
                let fileName = 'MerchantImportTmpl.xlsx'
                if ('download' in document.createElement('a')) {
                    // 非IE下载
                    var elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href)
                    document.body.removeChild(elink)
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
    
        // 上传
        httpRequest(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            merchantImport(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.dialogVisible = false
                        this.$emit('parent-update')
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err);
                })
        },
       
        // 关闭弹窗
        dialogClose () {
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
.content{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .upload-hint{
        margin-top: 20px;
        .text{
            text-align: center;
            line-height: 35px;
            font-size: 14px;
        }
        .download{
            margin-top: 10px;
            text-align: center;
            .clickable{
                font-size: 14px;
                color: #2D74FF;
            }
        }
    }
}

</style>
